'use client'

import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

import { ContentForm } from '../../ContentForm'
import {
	appFormConfig,
	platformFormConfig,
	qrNameFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from '../../contentFormSections'
import { QR_TYPE, TContentFormProps } from '../../generatorTypes'

export const AppContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			contentDesignFormConfig(t),
			appFormConfig(t),
			platformFormConfig(t),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.App} config={config} {...props} />
}
